import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
	selector: 'app-clever-login-button',
	standalone: true,
	templateUrl: './clever-login-button.component.html',
	styleUrls: ['./clever-login-button.component.scss'],
})
export class CleverLoginButtonComponent implements OnInit {
	ngOnInit(): void {}

	public onClick(): void {
		window.location.href =
			'https://clever.com/oauth/authorize?' + this.encodeQueryData(environment.clever);
	}

	private encodeQueryData(data: any): string {
		const ret = [];

		for (let d in data) {
			ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
		}

		return ret.join('&');
	}
}
